import React, { useState } from "react";
import '../../App.css';
//const MetaTags = require('react-meta-tags');


const homeImages: string[] = [
  "images/recent-work/its-me-in-the-window.jpg",
  "images/recent-work/heads.jpg",
  "images/recent-work/george-cuts.jpg",
  "images/recent-work/green-with-ivy.jpg",
  "images/recent-work/blue-cup.jpg",
  "images/recent-work/blue-bible.jpg",
  "images/recent-work/washing-line.jpg",
  "images/recent-work/beach-jade.jpg",
  "images/recent-work/2ps.jpg",
  "images/recent-work/three-chairs.jpg",
  "images/recent-work/red-light.jpg",
  "images/recent-work/roses.jpg",
  "images/recent-work/crack-of-light.jpg",
  "images/recent-work/blue-railing.jpg",
  "images/recent-work/swing.jpg",
  "images/recent-work/bk.jpg",
  "images/recent-work/grapes.jpg",
  "images/recent-work/orange-chair.jpg",
  "images/recent-work/milking-it.jpg",
  "images/recent-work/tube-man.jpg",
  "images/recent-work/glass-and-shadow.jpg",
  "images/recent-work/croc.jpg",
  "images/recent-work/moment.jpg",
  "images/recent-work/ketchup.jpg",
  "images/recent-work/ladies.jpg",
  "images/recent-work/wild-garlic.jpg",
  "images/recent-work/post-breakfast.jpg",
  "images/recent-work/abstract.jpg",
  "images/recent-work/church.jpg",
  "images/recent-work/open.jpg",
  "images/recent-work/heart-shaped-hole.jpg",
  "images/recent-work/tim.jpg",
  "images/recent-work/red-flower.jpg",
  "images/recent-work/easy-sunday.jpg",
  "images/recent-work/floating.jpg",
  "images/recent-work/cherry-curtains.jpg",
  "images/recent-work/piering.jpg",
  "images/recent-work/remains.jpg",
  "images/recent-work/man-in-white.jpg",
  "images/recent-work/late-night-laundrette.jpg",
  "images/recent-work/food-van.jpg",
  "images/recent-work/coke-can.jpg",
  "images/recent-work/lisa-birds.jpg",
  "images/recent-work/icecream-people.jpg",
  "images/recent-work/looking-at-shore.jpg",
  "images/recent-work/pink.jpg",
  "images/recent-work/guard.jpg",
  "images/recent-work/protest.jpg",
  "images/recent-work/dragon-ride.jpg",
  "images/recent-work/yellow-slice.jpg",
  "images/recent-work/green-stairs.jpg",
  "images/recent-work/empty-chair.jpg",
];

function Home(){
    const [heroImage, setHeroImage] = useState('images/banners/home.jpg');

    return (
      <div>
        {/* <MetaTags>
           <title>Matt Feeney Photography</title>
           <meta name="description" content="Matt Feeney Photography - Professional Photography Service based Lincoln" />
         </MetaTags> */}
         <div className="row justify-content-center">
              <img width="100%" className="col-11" src={heroImage} loading="lazy" />
          </div>
          <div className="row justify-content-center">
          {homeImages.map((src) => (
            <img
              key={src}
              src={src}
              className="col-11 col-lg-3 mt-5"
              width="100%"
              loading="lazy"
              onClick={() => setHeroImage(src)}
            />
          ))}
         </div>
      </div>
    );
}
export default Home;
